<template>
  <v-container fluid>
    <v-card>
      <!-- Encabezado con switch FAST/INBI integrado -->
      <v-toolbar flat color="transparent" class="mb-2">
        <v-toolbar-title class="headline font-weight-bold">
          <v-icon color="blue darken-2" large class="mr-2">mdi-checkbox-multiple-marked-circle</v-icon>
          Panel de Checklist Multimedia
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn-toggle v-model="instanciaGlobal" mandatory color="blue darken-2" background-color="white" group rounded>
          <v-btn value="inbi" small>INBI</v-btn>
           <v-btn value="fast" small>FAST</v-btn>
        </v-btn-toggle>
      </v-toolbar>

      <!-- Pestañas (Tabs) con diseño tipo transparente alineado a la izquierda -->
      <v-tabs v-model="tab" color="blue darken-2" background-color="transparent" class="mb-4">
        <v-tab><v-icon left small>mdi-format-list-checks</v-icon>Tareas de Checklist</v-tab>
        <v-tab><v-icon left small>mdi-instagram</v-icon>Plataformas</v-tab>
        <v-tab><v-icon left small>mdi-tag-multiple</v-icon>Temas</v-tab>
        <v-tab><v-icon left small>mdi-list-status</v-icon>Estados</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <ChecklistTareas v-if="tab === 0" :instancia="instanciaGlobal" />
        </v-tab-item>

        <v-tab-item>
          <CatPlataformas v-if="tab === 1" :instancia="instanciaGlobal" />
        </v-tab-item>

        <v-tab-item>
          <CatTemas v-if="tab === 2" :instancia="instanciaGlobal" />
        </v-tab-item>

        <v-tab-item>
          <CatEstados v-if="tab === 3" :instancia="instanciaGlobal" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import ChecklistTareas from './ChecklistTareas.vue';
import CatPlataformas from './CatPlataformas.vue';
import CatTemas from './CatTemas.vue';
import CatEstados from './CatEstados.vue';

export default {
  name: 'ChecklistContenidos',
  components: {
    ChecklistTareas,
    CatPlataformas,
    CatTemas,
    CatEstados
  },
  data() {
    return {
      instanciaGlobal: 'inbi',
      tab: 0,
    };
  }
};
</script>
